



  <div class="flex-row flex--align-center flex--justify-between border-primary-bottom full-width padding-standard"> 
    
    <div class="flex-column gap-small ">
      <h5 class="mat-headline-5 margin-none">{{ (actorObs | async)?.firstName + " " + (actorObs | async)?.lastName }}</h5>
      <h6 class="mat-body margin-none mat-mdc-card-subtitle">{{(actorObs | async)?.email}}</h6>
    </div>

    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </div>
  

  
  <div class="flex-column gap-small padding-standard" >
    <ss-batch-autocomplete></ss-batch-autocomplete>
    <ss-allowed-signature-types-checklist></ss-allowed-signature-types-checklist>

  </div>

  <div class="flex-row flex--align-center flex--justify-between padding-standard border-gray-bottom border-gray-top">
    <button mat-raised-button color="primary" (click)="save()"><mat-icon>check</mat-icon>{{'ss-general.save' | translate}}</button>  
    <button mat-raised-button (click)="close()"><mat-icon>cancel</mat-icon>{{'ss-general.cancel' | translate}}</button>
  </div>
    

